import type { Business } from '@/models/business.model';
import type { OnboardingVerification } from '@/models/onboarding-verification.model';
import type { OnboardingDocument } from '@/models/onboarding-document.model';

export enum OnboardingProduct {
  Factoring = 'Factoring',
  FleetCard = 'FleetCard',
}

export enum OnboardingApplicationStatus {
  Approved = 'Approved',
  Incomplete = 'Incomplete',
  ManualReview = 'Manual Review',
  PendingWorkflow = 'Pending Workflow',
  Rejected = 'Rejected',
}

export type OnboardingStatus = {
  applicationStatus: OnboardingApplicationStatus;
  business: Business;
  documents: OnboardingDocument;
  id: string;
  product: OnboardingProduct;
  verifications: OnboardingVerification[];
}
